// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__meBvo","container_video":"styles_container_video__av5-v","video":"styles_video__XEzt8","content":"styles_content__Y3oBF","button":"styles_button__esg0C"};